<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        
          <el-col :span="6">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width: 100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="6">
          <el-form-item label="咨询人姓名" prop="consultantName">
            <el-input
              clearable
              v-model="searchForm.consultantName"
              placeholder="咨询人姓名"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="老人姓名" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="老人姓名"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="咨询状态" prop="consultStatus">
            <el-select
              clearable
              v-model="searchForm.consultStatus"
              style="width: 100%"
              placeholder="咨询状态"
            >
              <el-option
                v-for="item in consultStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="接待人" prop="receiver">
            <el-input
              clearable
              v-model="searchForm.receiver"
              placeholder="接待人"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="咨询日期" prop="timeRange">
            <el-date-picker
              v-model="searchForm.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button v-if="permissionList.addBtn" type="primary" size="small" @click="addenquireForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button v-if="permissionList.viewBtn" type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>

        <el-button v-if="permissionList.editBtn" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button v-if="permissionList.delBtn" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="enquireFormTittle"
      :allowFull="false"
      width="60%"
      :visible.sync="enquireFormVisible"
    >
      <template slot="body">
        <enquireForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="enquireFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></enquireForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete,getNursinghome } from '../api/serveItemManage.js';
import enquireForm from './enquireForm.vue';
import { getDictionary } from '@/api/common.js';
import { nursingPage } from '../api/enquire.js';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

import searchFromShow from '@/components/search-form-show/index';

export default {
  components: { searchFromShow, enquireForm },
  data() {
    return {
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      enquireFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        timeRange: [],
        nursinghomeId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },

      projectList: [],

      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '咨询人姓名',
            prop: 'consultantName',
          },
          {
            label: '咨询日期',
            prop: 'consultTime',
          },
          {
            label: '联系电话',
            prop: 'tel',
          },
          {
            label: '老人姓名',
            prop: 'name',
          },
          {
            label: '老人身份证号',
            prop: 'idNumber',
          },
          {
            label: '咨询方式',
            prop: 'consultWay',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_consult_way_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '媒体渠道',
            prop: 'mediaChannel',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_media_channel_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '状态',
            prop: 'consultStatus',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_consult_status_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '接待人',
            prop: 'receiver',
          },
          {
            label: '登记人',
            prop: 'registrant',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      consultStatusList: [],
      data: [],
      nursinghomeIdList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.enquire_view, false),
        addBtn: this.vaildData(this.permission.enquire_add, false),
        editBtn: this.vaildData(this.permission.enquire_edit, false),
        delBtn: this.vaildData(this.permission.enquire_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
      self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    }
  },
  activated(){
      this.$refs.crud.doLayout();
  },
  methods: {
    addenquireForm() {
      this.enquireFormTittle = '新增';
      this.formModel = 'add';
      this.enquireFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },
    searchRecord() {
      this.page.currentPage = 1;

      this.onLoad();
    },
    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          stockWarnDelete(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    selectionChange(val) {
      this.selectionList = val;
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.selectionIds = Ids.join(',');
    },
    // 数据导出

    editRecord(row) {
      this.enquireFormTittle = '修改';
      this.formModel = 'edit';
      this.formRow = row;
      this.enquireFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.enquireFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.enquireFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.enquireFormTittle = '查看';

      this.formModel = 'view';
      this.formRow = row;
      this.enquireFormVisible = true;
    },

    searchClear() {
      this.tool.clearObject(this.searchForm);
      this.searchForm.nursinghomeId = this.nursinghomeIdList[0].id;
      this.onLoad();
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getDictionary('nursinghome_consult_status_type').then((res) => {
        this.consultStatusList = res.data;
      });
      
      getNursinghome({ id: this.nursinghomeId }).then(res=>{
        this.nursinghomeIdList = res.data;
        this.searchForm.nursinghomeId = res.data[0].id;
        this.onLoad();
      })
    },
    transferTime() {
      console.log('this.searchForm.timeRange=========>', this.searchForm.timeRange);
      if (this.searchForm.timeRange && this.searchForm.timeRange.length > 0) {
        this.searchForm.timeStart = dayjs(this.searchForm.timeRange[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.searchForm.timeEnd = dayjs(this.searchForm.timeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.searchForm.timeStart = '';
        this.searchForm.timeEnd = '';
      }
    },
    onLoad() {
      this.transferTime();
      nursingPage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  